const Types = {    
    TIPO: '@cadastrar-caixa/TIPO',
    CLEAR: '@cadastrar-caixa/CLEAR',
    SEQUENCIAL_ORIGINAL_REQUEST: '@cadastrar-caixa/SEQUENCIAL_ORIGINAL_REQUEST',
    SEQUENCIAL_COPIA_REQUEST: '@cadastrar-caixa/SEQUENCIAL_COPIA_REQUEST',
    SEQUENCIAL_SUCCESS: '@cadastrar-caixa/SEQUENCIAL_SUCCESS',
    INSERT_REQUEST: '@cadastrar-caixa/INSERT_REQUEST',
    INSERT_SUCCESS: '@cadastrar-caixa/INSERT_SUCCESS',
    SEARCH_CAIXA_REQUEST: '@cadastrar-caixa/SEARCH_CAIXA_REQUEST',
    SEARCH_CAIXA_SUCCESS: '@cadastrar-caixa/SEARCH_CAIXA_SUCCESS',
    REQUEST_FAILURE: '@cadastrar-caixa/REQUEST_FAILURE',
};

export default Types;